import { RouterEntitiesId } from '@vizsla/constants';

/** @deprecated use RouterEntitiesId from @vizsla/constants package */
export const { experience, fundraiser, donationOption } = RouterEntitiesId;
